import config from 'config/config'
import { globalize } from 'databinding/globalize'
import React from 'react'
import Divider from 'semantic-ui-react/dist/commonjs/elements/Divider'
import Header from 'semantic-ui-react/dist/commonjs/elements/Header'
import translations from './_Footer.i18n.json'

class ContactInfo extends React.PureComponent {
  render() {
    const {
      globalize: { translate, language },
    } = this.props

    return (
      <React.Fragment>
        <Header as="h3" children={translate('contact.main_office')} />
        <p>
          <strong>{config.company.name[language]}</strong>
          <br />
          {config.company.mainAddress2}
          <br />
          {config.company.mainZip} {config.company.mainCity}
          <br />
        </p>
        <Divider hidden clearing />
        <p>
          <a href={`tel:${config.company.mainPhone}`}>{config.company.mainPhone}</a>
          <br />
          <a href={`mailto:${config.company.email}`}>{config.company.email}</a>
        </p>
        <p>
        </p>
        <Divider hidden clearing />
        <p>
          <strong>{translate('contact.business_hours')}</strong>
          <br />
          {translate('contact.weekdays')} <br />
          {config.company.mainOpeningHours}
        </p>
      </React.Fragment>
    )
  }
}

ContactInfo = globalize({ translations })(ContactInfo)
export default ContactInfo
